import React from "react";
import logo from "../assets/img/logo1.png";
import {
    FaGem,
    FaList,
    FaBars,
    FaCalendarAlt,
    FaTrello,
    FaRegUser,
    FaRegFileAlt,
    FaRegImages,
    FaRegFileCode,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

import { useAuth } from "../auth/AuthProvider";
import { ACCESS } from "./constant";

import "./css/SideBar.css";

const SideBar = ({
    handleMouseLeave,
    handleMouseEnter,
    toggled,
    setToggled,
    setBroken,
    collapsed,
}) => {
    const { can } = useAuth();

    return (
        <>
            <div
                onMouseEnter={() => handleMouseEnter()}
                onMouseLeave={() => handleMouseLeave()}
                style={{ display: "flex", height: "100%", flexDirection: "column" }}
            >
                <Sidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    onBackdropClick={() => setToggled(false)}
                    onBreakPoint={setBroken}
                    breakPoint="md"
                    className="sidebar-container"
                    style={{ zIndex: "9999", backgroundColor: "#f8f9fa" }}
                >
                    <div className="sidebar-header">
                        <img src={logo} alt="logo" className="ve-logo" />
                        {!collapsed && <span>VECLOUD</span>}
                    </div>

                    <Menu iconShape="circle">
                       {can(ACCESS.DASHBOARD) && (
                            <MenuItem
                                icon={<FaGem />}
                                component={<Link to="/dashboard" className="link-underline" />}
                            >
                                Dashboard
                            </MenuItem>
                       )}

                        {can(ACCESS.REPORT) && (
                            <MenuItem
                                icon={<FaRegFileCode />}
                                component={<Link to="/transactions" className="link-underline" />}
                            >
                                Sales Report
                            </MenuItem>
                        )}

                        {can(ACCESS.MRO_REPORT) && (
                            <SubMenu label="MRO Report" icon={<FaRegFileAlt />}>
                                <MenuItem component={<Link to="/mro-transactions" />}>
                                    By Transaction
                                </MenuItem>
                                <MenuItem component={<Link to="/mro-transactions-by-product" />}>
                                    By Product
                                </MenuItem>
                                <MenuItem component={<Link to="/mro-transactions-by-employee" />}>
                                    By Employee
                                </MenuItem>
                            </SubMenu>
                        )}

                        {can(ACCESS.INVENTORY) && (
                            <SubMenu label="Inventory" icon={<FaBars />}>
                                <MenuItem component={<Link to="/products" />}>Product</MenuItem>
                                <MenuItem component={<Link to="/categories" />}>Category</MenuItem>
                            </SubMenu>
                        )}

                        {can(ACCESS.VENDING_MACHINE) && (
                            <SubMenu label="Vending Machine" icon={<FaRegImages />}>
                                <MenuItem component={<Link to="/machines" />}>Status</MenuItem>
                            </SubMenu>
                        )}

                        {can(ACCESS.USER) && (
                            <MenuItem
                                icon={<FaRegUser />}
                                component={<Link to="/users" className="link-underline" />}
                            >
                                Users
                            </MenuItem>
                        )}

                        {can(ACCESS.MRO) && (
                            <SubMenu label="MRO" icon={<FaCalendarAlt />}>
                                <MenuItem component={<Link to="/employees" />}>Employee</MenuItem>
                                <MenuItem component={<Link to="/employeeTypes" />}>Type</MenuItem>
                                <MenuItem component={<Link to="/employeeTopup" />}>Topup</MenuItem>
                            </SubMenu>
                        )}
                        {can(ACCESS.NOTIFICATIONS) && (
                            <MenuItem
                                icon={<FaTrello />}
                                component={<Link to="/notifications" className="link-underline" />}
                            >
                                Notifications
                            </MenuItem>
                       
                        )}
                    </Menu>
                </Sidebar>
            </div>
        </>
    );
};

export default SideBar;
